export enum DurationTypes {
  Days = 'DAYS',
  Weeks = 'WEEKS',
  Months = 'MONTHS',
  Years = 'YEARS',
}

export type DurationType = DurationTypes.Days | DurationTypes.Weeks | DurationTypes.Months | DurationTypes.Years;
